import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  VideoResponsePrequalResponse,
  IVideoResponsePrequalQuestionModelState,
  IVideoResponsePrequalResponseValidation,
  VideoResponsePrequalQuestionModelTypes
} from './types'

const VideoResponsePrequalQuestionModel: IQuestionModelConstructor<VideoResponsePrequalQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const { model } = BaseQuestionModel<VideoResponsePrequalQuestionModelTypes, IVideoResponsePrequalQuestionModelState>({
    questionType: QuestionType.VIDEO_RESPONSE_PREQUAL,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IVideoResponsePrequalQuestionModelState) {
  return response
    .filter(responseAnswer => responseAnswer.selected)
    .map(responseAnswer => {
      return { id: responseAnswer.id }
    })
}

function initState(state: IVideoResponsePrequalQuestionModelState): IVideoResponsePrequalQuestionModelState {
  state.response = state.questionSchema.answers.map<ArrayElementType<VideoResponsePrequalResponse>>(answer => {
    return { id: answer.id, mark: 'empty', selected: false, na: !answer.positive }
  })
  return state
}

function validateResponse({
  response
}: IVideoResponsePrequalQuestionModelState): IVideoResponsePrequalResponseValidation {
  return {
    valid: response.some(item => item.selected)
  }
}

export default VideoResponsePrequalQuestionModel
